<template>
  <div data-simplebar data-simplebar-auto-hide="false" v-bind="$attrs" v-on="$listeners">
    <slot />
  </div>
</template>

<script>
// import 'simplebar'
// import 'simplebar/dist/simplebar.css'
export default {}
</script>

<style scoped>
.simplebar-scrollbar::before {
  background-color: red;
}
</style>
